/* Gift Reggie owns the request. Observe its native result; never infer success from a click. */
(() => {
  'use strict';
  const selector = '.giftreggie-pdp-registry-cta';
  const states = new WeakMap();
  let panel;
  let active;

  function settings() {
    let data = {};
    try { data = JSON.parse(document.getElementById('gift_reggie_data')?.textContent || '{}'); } catch (_) { /* App not ready. */ }
    document.querySelectorAll('[data-gift-reggie-data-override]').forEach(element => {
      try {
        const override = JSON.parse(element.textContent || '{}');
        const registry = { ...data.i18n?.registry, ...override.i18n?.registry };
        data = { ...data, ...override, i18n: { ...data.i18n, ...override.i18n, registry } };
      } catch (_) { /* Ignore malformed optional overrides, as the app does. */ }
    });
    return data;
  }

  function registryUrl() {
    const data = settings();
    let id;
    try {
      const managed = JSON.parse(localStorage.getItem('giftreggie-logged') || '{}');
      const cached = JSON.parse(localStorage.getItem('giftreggie-cache') || '{}');
      id = (managed.admin && managed.registry_id) || (data.registryAdmin && data.registryId) || cached.customer_registry_id;
    } catch (_) { /* The registry landing page also works when storage is unavailable. */ }
    const root = String(data.rootUrl || '/').replace(/\/$/, '');
    return root + '/apps/giftregistry' + (/^\d+$/.test(String(id)) ? '/registry/' + id : '');
  }

  function productForm(button) {
    let area = button.parentElement;
    while (area) {
      const forms = Array.from(area.querySelectorAll('form[action*="/cart/add"]'));
      if (forms.length) {
        return forms.sort((a, b) => score(b) - score(a))[0];
      }
      area = area.parentElement;
    }
    return null;
  }

  function score(form) {
    return Number(!!form.querySelector('[name="id"]')) + Number(!!form.querySelector('[name="quantity"]')) +
      Number(!!form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]'));
  }

  function selection(button) {
    const form = productForm(button);
    const fields = form ? Array.from(new FormData(form).entries()) : [];
    const options = fields.filter(([key, value]) => /^properties\[[^_][^\]]*\]$/.test(key) && value)
      .map(([key, value]) => key.slice(11, -1) + ': ' + String(value));
    return {
      signature: JSON.stringify(fields.filter(([key]) => key === 'id' || key === 'quantity' || key.startsWith('properties['))),
      options: options.join(' · '),
      title: (button.closest('product-page')?.querySelector('h1') || document.querySelector('h1'))?.textContent.trim() || ''
    };
  }

  function buildPanel() {
    panel = document.createElement('aside');
    panel.className = 'pa-registry-feedback';
    panel.hidden = true;
    panel.setAttribute('aria-label', 'Tu lista de nacimiento');
    panel.innerHTML = '<button type="button" class="pa-registry-feedback__close" aria-label="Cerrar aviso">×</button>' +
      '<div role="status" aria-live="polite" aria-atomic="true"><p class="pa-registry-feedback__title"></p>' +
      '<p class="pa-registry-feedback__product"></p><p class="pa-registry-feedback__options"></p></div>' +
      '<div class="pa-registry-feedback__actions"><a class="pa-registry-feedback__view">Ver mi lista</a>' +
      '<button type="button" class="pa-registry-feedback__continue">Seguir comprando</button></div>';
    panel.querySelectorAll('button').forEach(button => button.addEventListener('click', closePanel));
    document.body.appendChild(panel);
  }

  function closePanel() {
    const hadFocus = panel.contains(document.activeElement);
    panel.hidden = true;
    if (hadFocus) {
      const target = active?.button.closest('product-page')?.querySelector('h1') || document.querySelector('h1');
      if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    }
  }

  function show(state) {
    if (!panel) buildPanel();
    active = state;
    panel.hidden = false;
    panel.dataset.state = state.phase;
    const messages = {
      pending: 'Añadiendo a tu lista…',
      success: '✓ Producto añadido a tu lista',
      error: 'No hemos podido añadirlo. Inténtalo de nuevo.',
      uncertain: 'No podemos confirmar que se haya añadido. Revisa tu lista antes de intentarlo de nuevo.',
      login: 'Inicia sesión para añadirlo a tu lista. Te estamos llevando allí…'
    };
    const status = panel.querySelector('[role="status"]');
    status.setAttribute('aria-busy', String(state.phase === 'pending'));
    panel.querySelector('.pa-registry-feedback__title').textContent = messages[state.phase];
    panel.querySelector('.pa-registry-feedback__product').textContent = state.selection.title;
    const options = panel.querySelector('.pa-registry-feedback__options');
    options.textContent = state.selection.options;
    options.hidden = !state.selection.options || !['success', 'pending'].includes(state.phase);
    const view = panel.querySelector('.pa-registry-feedback__view');
    view.href = registryUrl();
    view.hidden = !['success', 'uncertain', 'error'].includes(state.phase);
  }

  function buttonState(state) {
    const labels = {
      idle: 'Agregar a la lista de nacimiento', pending: 'Añadiendo…',
      success: '✓ Añadido a tu lista', error: 'Volver a intentarlo',
      uncertain: 'Revisa tu lista', login: 'Inicia sesión…'
    };
    const button = state.button;
    button.dataset.paRegistryState = state.phase;
    button.dataset.paRegistryLabel = labels[state.phase];
    button.setAttribute('aria-label', labels[state.phase]);
    const locked = ['pending', 'success', 'login'].includes(state.phase);
    button.setAttribute('aria-busy', String(state.phase === 'pending'));
    if (locked) { button.disabled = true; state.ownsLock = true; }
    else if (state.ownsLock) { button.disabled = false; state.ownsLock = false; }
  }

  function observe(button) {
    if (states.has(button)) return states.get(button);
    const state = { button, phase: 'idle', ownsLock: false };
    states.set(button, state);
    const observer = new MutationObserver(() => {
      // The app resets disabled when its one-second feedback expires.
      if (['pending', 'success', 'login'].includes(state.phase) && !button.disabled) {
        button.disabled = true;
      }
      if (!['pending', 'uncertain'].includes(state.phase)) return;
      const text = (button.textContent || button.title || '').trim();
      const language = settings().i18n?.registry;
      if (!language) return;
      if (text === language.error?.trim()) state.phase = 'error';
      else if (text === language.successAdd?.trim()) state.phase = 'success';
      else return;
      clearTimeout(state.timer);
      buttonState(state);
      show(state);
      if(state.phase==='success')document.dispatchEvent(new CustomEvent('pa:registry-added',{detail:{button}}));
    });
    observer.observe(button, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['title', 'disabled'] });
    buttonState(state);
    return state;
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    const state = observe(button);
    if (['pending', 'success', 'uncertain', 'login'].includes(state.phase)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      show(state);
      return;
    }
    state.selection = selection(button);
    state.phase = settings().customerId ? 'pending' : 'login';
    buttonState(state);
    show(state);
    state.timer = setTimeout(() => {
      if (!['pending', 'login'].includes(state.phase)) return;
      state.phase = 'uncertain';
      buttonState(state);
      show(state);
    }, 25000);
  }, true);
  document.addEventListener('pa:registry-review',event=>{
    const state=states.get(event.detail?.button);
    if(state?.phase==='uncertain')show(state);
  });

  // A different selection can be added; the same confirmed click stays locked on this page.
  function resetChangedSelection() {
    document.querySelectorAll(selector).forEach(button => {
      const state = states.get(button);
      if (state?.phase !== 'success' || selection(button).signature === state.selection.signature) return;
      state.phase = 'idle';
      buttonState(state);
      if (active === state && panel) panel.hidden = true;
    });
  }
  document.addEventListener('change', () => setTimeout(resetChangedSelection, 30));
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-sb-io-swatch]')) setTimeout(resetChangedSelection, 30);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && panel && !panel.hidden) closePanel(); });
  document.querySelectorAll(selector).forEach(observe);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) observe(node);
    node.querySelectorAll(selector).forEach(observe);
  }))).observe(document.body, { childList: true, subtree: true });
})();
